'use strict';

angular.module('libraryModule')

.config(function (modalStateProvider)
{
    modalStateProvider.state('admin.media.edit-folder-thumb', {
        url: '/edit-folder-thumb/{id:[0-9]+}',
        controller: 'EditLibraryFolderCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'library/library.modals/library.edit-folder.modal.html',
        resolve: {
            model: ['Asset', 'modalState', function (Asset, modalState)
            {
                return Asset.find(modalState.stateParams.id).then(function (data)
                {
                    modalState.model = data;
                    return modalState.model;
                });
            }],
            files: ['File', 'modalState', function (File, modalState)
            {
                var params = {asset_id: modalState.stateParams.id};
                File.ejectAll(params);

                return File.findAll(params);
            }],
            actions: ['Action', function (Action)
            {
                return Action.findAll();
            }]
        }
    });
});
